// @ts-nocheck
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Label } from '@/components/ui/label';
import SectionCard from './SectionCard';

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
};
// Quill 2: 'bullet' is not a format — bullet lists are values of 'list'
// (listing it here makes Quill log a registry error and register nothing).
const QUILL_FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background', 'list', 'indent', 'link',
];

export default function MessagingAccessSection({ d, registrationName }) {
  const { draft, setField, dirtyBySection, savingSection, saveSection } = d;

  return (
    <SectionCard
      id="messaging"
      title="Messages"
      description="What registrants see at the start and end of sign-up."
      dirty={dirtyBySection.messaging}
      saving={savingSection === 'messaging'}
      onSave={() => saveSection('messaging')}
    >
      <div className="space-y-2">
        <Label className="text-base font-medium">Welcome message</Label>
        <div className="quill-editor">
          <ReactQuill
            placeholder={`Welcome${registrationName ? ` to the ${registrationName}` : ''}, please enter your team information in order to register`}
            value={draft.message}
            onChange={(v) => setField('message', v)}
            modules={QUILL_MODULES}
            formats={QUILL_FORMATS}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-base font-medium">Thank-you message</Label>
        <div className="quill-editor">
          <ReactQuill
            placeholder="Thank you for registering. Below is a summary of your registration details."
            value={draft.thankYouMessage}
            onChange={(v) => setField('thankYouMessage', v)}
            modules={QUILL_MODULES}
            formats={QUILL_FORMATS}
          />
        </div>
      </div>

    </SectionCard>
  );
}
